

      export  const highlightMatch = (text, search) => {
        if (!search) return text;
        const regex = new RegExp(`(${search})`, "gi");
        return text.replace(regex, `<span class="highlight-text">$1</span>`);
    };